<script lang="ts">
  import {userData, userSignedIn } from "../store";

 
</script>
<div class="border-bottom" />

<div class="privacy-policy">

  <p>
    Your data is never distributed to third parties. Contact <a href="https://aiobfuscation.com">Artificial Intelligence Obfuscation LLC</a> to learn more.
  </p>
  <a href="/privacypolicy.html">Privacy Policy</a> - V3.0.0
  
</div>

